/// <reference types="googlemaps" />
import {Directive, ElementRef, EventEmitter, NgZone, OnInit, Output} from '@angular/core';

@Directive({
  selector: '[pegasusGooglePlaces]',
  standalone: true
})
export class GooglePlacesDirective implements OnInit {

  @Output() onSelect: EventEmitter<any> = new EventEmitter();

  private autocomplete: any;

  constructor(private elRef: ElementRef, private ngZone: NgZone) {}

  ngOnInit() {
    this.initAutocomplete();
  }

  private initAutocomplete(): void {
    this.autocomplete = new google.maps.places.Autocomplete(this.elRef.nativeElement, {
      types: [], // Specify the type of places to search
      componentRestrictions: { country: 'IN' }
    });

    this.autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        // Get the place result
        let place: google.maps.places.PlaceResult = this.autocomplete.getPlace();

        // Emit the "onSelect" event with place result
        this.onSelect.emit(place);
      });
    });
  }

}
